import { DataBean } from "../DataBean";

export class InterestMora extends DataBean {



    public async getInterestMoraCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("CreditCore", "java.util.List_getInterestMoraCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }
        public async getInterestMoraRender(year:any): Promise<any> {
        return this.getCustomService("CreditCore", "java.util.List_getInterestMoraRender_Number", [year]);
    }
    
}